import { PUBLIC_URL } from '../../utils/constants';

export default {
  MICROSOFT_LOGIN_PAGE: `${PUBLIC_URL}/auth/microsoft`,
  LOGIN_PAGE: `${PUBLIC_URL}/auth/login`,
  HR_LOGIN_PAGE: `${PUBLIC_URL}/auth/hr`,
};
